import * as types from './mutations-type'

const mutations = {
  /**
   * 设置是否是移动端
   */
  [types.CHECK_MOBILE] (state, mobile) {
    state.isMobile = mobile
  },
  [types.SET_LANG] (state, lang) {
    state.lang = lang
    // state.isEnLang = lang === 'en-US'
  },
  // 设置全局 layer
  [types.SET_GLOBAL_LAYERS] (state, layers) {
    state.globalLayers = layers
  }
}

export default mutations
